// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.collapse-icon[data-v-677b267c]{\n  position: relative;\n  padding-right: 8px;\n  padding-left: 0px;\n}\n.padding-title[data-v-677b267c] {\n  text-wrap: nowrap;\n  padding: 4px 0px;\n}\n.padding-icon[data-v-677b267c] {\n  padding-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
